import React, { useState } from "react";
import {
  Col,
  DatePicker,
  Image,
  Row,
} from "../../common/utils/antd-imports/AntdImports";
import calendarIcon from "../../../assests/Calendar_Icon.svg";
import "antd/dist/reset.css";
import "./CalendarComponent.css";
import enUS from "antd/es/date-picker/locale/en_US";
import { useMediaQuery } from "react-responsive";
const CalendarComponent = ({
  label,
  onDateRangeChange,
  disabled,
  placement,
  ...props
}) => {
  const { RangePicker } = DatePicker;
  const [open, setOpen] = useState(false);
  const [dateRange, setDateRange] = useState(null);
  const isMobile = useMediaQuery({ maxWidth: 769 });
  const customLocale = {
    ...enUS,
    lang: {
      ...enUS.lang,
      shortWeekDays: ["S", "M", "T", "W", "T", "F", "S"],
    },
  };
  const handleImageClick = () => {
    setOpen(true);
  };

  const handleDatePickerChange = (dates) => {
    setDateRange(dates);
    setOpen(false);
    if (onDateRangeChange) {
      onDateRangeChange(dates);
    }
  };
  const handleOpenChange = (isOpen) => {
    setTimeout(() => setOpen(isOpen), 50);
  };
  const disabledDate = (current) => {
    // return current && current < dayjs().startOf("day"); // Disable past dates
  };
  return (
    <div>
      <Row align="middle">
        <Col span={17} className="range-picker-common">
          <RangePicker
            {...props}
            locale={customLocale}
            getPopupContainer={
              isMobile ? (triggerNode) => triggerNode.parentNode : ""
            }
            open={open}
            placeholder={label}
            variant="borderless"
            suffixIcon={false}
            superNextIcon={false}
            superPrevIcon={false}
            onOpenChange={handleOpenChange}
            onChange={handleDatePickerChange}
            value={dateRange}
            className="calendar-comp rfp-dma-calendar-component"
            disabledDate={disabledDate}
            placement="bottomRight"
            //used the calender col wise
            size={"small"}
          />
        </Col>
        <Col span={4}>
          <Image
            src={calendarIcon}
            alt=""
            preview={false}
            onClick={handleImageClick}
            className="calendar-icon-image"
          />
        </Col>
      </Row>
    </div>
  );
};

export default CalendarComponent;
